// extracted by mini-css-extract-plugin
module.exports = {"addressCard":"AddressCard_addressCard__2tCLT","addressCardContainer":"AddressCard_addressCardContainer__112Nx","info":"AddressCard_info__JJmcM"};